export default __webpack_public_path__ + "static/media/Team.55a3e7c2.jpg";